module.exports = __webpack_public_path__ + "img/q30-2.f99dca9d.jpg";